import Crud from '../views/Role/Crud'
import Entity from '../views/Role/Add'

let routes = {
    path: '/roles',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/roles/add',
            name: 'NewRole',
            component: Entity,
            meta: {
                pageTitle: 'role.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'role.add.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/roles/edit/:id?',
            name: 'EditRole',
            component: Entity,
            meta: {
                pageTitle: 'role.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'role.add.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/roles',
            name: 'list-roles',
            component: Crud,
            meta: {
                pageTitle: 'role.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'role.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes
